export default __webpack_public_path__ + "static/application-c7ca1f95f08fc45b6702165b736c8c0d.mp4";